import { X } from 'lucide-react';
import { SUPPORT_CONTACT_ITEMS } from '../constants/supportContactItems';
import { useSupportApiError } from '../contexts/SupportApiErrorContext';
import { useTranslation } from '../hooks/useTranslation';
import { isSupportBannerForced } from '../utils/supportApiErrorNotifier';
import './SupportErrorBanner.css';

function SupportErrorBanner() {
  const { t } = useTranslation();
  const { showSupportBanner, clearSupportBanner } = useSupportApiError();

  if (!showSupportBanner) {
    return null;
  }

  const forced = isSupportBannerForced();

  return (
    <div className="support-error-banner" role="alert">
      <div className="support-error-banner__inner">
        <p className="support-error-banner__message">{t('support.api.banner.message')}</p>
        <div className="support-error-banner__contact">
          <p className="support-error-banner__contact-title">{t('maintenance.contact.title')}</p>
          <ul className="support-error-banner__contact-list">
            {SUPPORT_CONTACT_ITEMS.map((item) => {
              const Icon = item.icon;
              return (
                <li key={item.key}>
                  <a
                    href={item.href}
                    className="support-error-banner__contact-link"
                    target={item.href.startsWith('http') ? '_blank' : undefined}
                    rel={item.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                  >
                    <Icon size={18} strokeWidth={1.5} aria-hidden="true" />
                    <span>{t(item.key)}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        {!forced && (
          <button
            type="button"
            className="support-error-banner__dismiss"
            onClick={clearSupportBanner}
            aria-label={t('support.api.banner.dismiss')}
          >
            <X size={20} strokeWidth={2} aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
}

export default SupportErrorBanner;
